import { Record } from 'immutable';
import { UnknownAction } from 'redux';

export interface UndoProps {
  key?: string;
  actions?: UnknownAction[];
  userMessage?: string;
  disableUndoAction?: boolean;
}

export const mkUndo = Record<UndoProps>({
  key: undefined,
  actions: undefined,
  userMessage: undefined,
  disableUndoAction: undefined,
});
